export type AssetDeviceCategory = 'MOBILE' | 'TABLET' | 'DESKTOP' | 'UNKNOWN';
export type AssetUploadProvenance = {
  uploadMethod?: 'RECORDED' | 'FILE_UPLOAD';
  deviceCategory?: AssetDeviceCategory;
};

// Browser hints, not viewport width or authorization. No raw UA is persisted.
export const assetDeviceCategory = (
  browser: { userAgent?: string; maxTouchPoints?: number } | undefined = typeof navigator ===
  'undefined'
    ? undefined
    : navigator,
): AssetDeviceCategory => {
  const ua = browser?.userAgent ?? '';
  if (/iPad|Tablet/i.test(ua) || (/Macintosh/i.test(ua) && (browser?.maxTouchPoints ?? 0) > 1))
    return 'TABLET';
  if (/iPhone|iPod/i.test(ua)) return 'MOBILE';
  if (/Android/i.test(ua)) return /Mobile/i.test(ua) ? 'MOBILE' : 'TABLET';
  if (/Windows NT|Macintosh|X11|CrOS/i.test(ua)) return 'DESKTOP';
  return 'UNKNOWN';
};
